export default __webpack_public_path__ + "static/empty_page_1-b7d211ceaaaf5399b9fbeccd8daa528c.png";